var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFeatureEvent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M13.056 8.1h12.888V5h3.223v3.1H34V36H5V8.1h4.833V5h3.223v3.1ZM8.223 32.9h22.554V17.4H8.223v15.5Zm13.463-9.712 4.314.384-3.276 2.988.984 4.44L20 28.645 16.292 31l.984-4.44L14 23.572l4.314-.384L20 19l1.686 4.188ZM8.223 14.3h22.554v-3.1H8.223v3.1Z"
})));
export default SvgFeatureEvent;